export const genericShortAnswerTemplate = {
  id: 'genericShortAnswer',
  title: 'Custom Short Answer',
  description: 'A flexible template for short answer questions that don\'t fit other categories — activities, experiences, or open-ended prompts',
  wordTarget: 250,
  sections: [
    {
      id: 'your_hook',
      label: 'Your Hook',
      type: 'opening',
      prompt: 'Start with the most specific, vivid detail about your answer. Drop the reader into a concrete moment or observation.',
      coachVoice: "Short answers have no room for warm-up. Your first sentence needs to do real work. Instead of 'I am passionate about...' or 'One experience that shaped me...', start with a detail that makes the reader want to know more. A specific image, a surprising fact, a moment of tension.",
      sample: "The spreadsheet had 847 rows — one for every family in our school district who'd missed at least three parent-teacher conferences in two years. My statistics teacher saw a data set. I saw my neighbors.",
      minWords: 40,
      unlockWords: 20
    },
    {
      id: 'the_core',
      label: 'The Core',
      type: 'substance',
      prompt: 'Develop your main point. What did you do, learn, create, or discover? Give specific details and evidence.',
      coachVoice: "This is the meat of your answer. Every sentence should earn its place. If you can remove a sentence without losing meaning, remove it. Specifics beat generalities: names, numbers, methods, outcomes. 'I helped the community' says nothing. 'I redesigned the conference scheduling system to include evening and weekend slots, and attendance increased 34%' says everything.",
      sample: "I partnered with the PTA to redesign the conference system. Instead of assuming families could take off work at 2 PM on a Tuesday, we added evening slots, Saturday sessions, and a phone-in option. I personally called thirty families to ask what times actually worked for them. The conversations taught me more about systemic barriers than any textbook — one parent worked three jobs and had never been invited to participate in a way that acknowledged her schedule.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'the_connection',
      label: 'The Connection',
      type: 'growth',
      prompt: 'Connect this back to the prompt and to who you are. What does this reveal about how you think or what you value?',
      coachVoice: "Land the plane. In a short answer, the ending needs to connect your specific story back to the bigger picture — who you are, what you care about, or how this connects to the program. Don't introduce new ideas here; deepen the ones you've already raised.",
      sample: "That project taught me that data without empathy is just numbers, and empathy without data is just feelings. I want to keep building at that intersection — using quantitative skills to solve problems that start with listening to the people who live them.",
      minWords: 40,
      unlockWords: 20
    }
  ]
};
